import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class TimeTrackerService {
  constructor() {
  }

  public static clearLocalStorage() {
    localStorage.removeItem('track_user_end_date');
    localStorage.removeItem('track_user_start_date');
    localStorage.removeItem('track_user_elapsed_time');
  }
}
